export enum ETabs {
  BASIC_INFO = 'Basic Info',
  YOUR_WEBSITE = 'Your Website',
  PAYMENT_METHODS = 'Payment Methods',
  BILLING_HISTORY = 'Invoice and Billing History',
}
